export default __webpack_public_path__ + "static/media/delete.02041110.svg";